import { useAppState } from "../../context/appStateContext"
import styles from "./FullScreenPage.module.scss"

interface Props {
  containerClassName?: string
  addInsetPadding?: boolean
}

const FullScreenPage = (props: React.PropsWithChildren<Props>) => {
  const { initialData } = useAppState().state

  const paddingTop = initialData?.topInset ?? 0
  const paddingBottom = initialData?.bottomInset ?? 0

  const style = props.addInsetPadding
    ? {
        paddingTop,
        paddingBottom,
      }
    : {}

  return (
    <div
      className={`${styles.container} ${props.containerClassName ?? ""}`}
      style={style}
    >
      {props.children}
    </div>
  )
}

export default FullScreenPage
